var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex items-center",attrs:{"disabled":_vm.loading}},[(_vm.loading)?_c('i',{staticClass:"fad fa-spin fa-spinner mr-2"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }